import 'uni-pages';import 'uni-h5';import Vue from 'vue'
import App from './App'
import bus from '@/utils/eventBus'
import JSEncrypt from "jsencrypt"

Vue.config.productionTip = false

App.mpType = 'app'

// 引入全局uView JS
import uView from 'uview-ui';
Vue.use(uView);

//对称加密
const publicKeyStr='MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjTvph3Qn6qIwSlCQs1Lw' +
          's4Q6qiBXwJojomfDajSkRfSm8sFnBdxhFf40IheZH4iyHRIZeC4d3f2pYH3uKJQU' +
          'Q8J/FwYN3DOKD38yqphcLTblpQFQiC5saDRZL/As6VxZF38DymjXyrH7VEUqSdAd' +
          'EH2VBS7me+fcYtadDnh0v+/tkb3OgmDCHC8YGELq4hL2NDOxoI3sA97/RLB5q5Us' +
          'ySxFoSxKE7bTRYJHio599QhMc1b6V91oJy/Fjc0poJ6Wko2HGD9AMY2FrYFtSyKJ' +
          'DLJ/22RVrCeVmuEVGkeW6q2iKVIet3H2e8DFFcaJQRhlM4m3HUVcoYWloQSrx+4N' +
          'kwIDAQAB'
const jsRsa = new JSEncrypt();
jsRsa.setPublicKey(publicKeyStr);

Vue.prototype.jsRsa = jsRsa


// 路由
import { router, RouterMount } from './router'
Vue.use(router)

import store from './store'
const app = new Vue({
  ...App,
  store
})
import './permission'

// 将各个定义的接口名称，统一放进对象挂载到vm.$api(因为vm就是this，也即this.$api)下
import * as api from '@/api'
Vue.prototype.$api = { ...api, ...api.default }

import filters from '@/filters'
Vue.use(filters)


import Utils from '@/utils'
Vue.use(Utils)












//v1.3.5起 H5端 你应该去除原有的app.$mount();使用路由自带的渲染方式

RouterMount(app, router, '#app');



